import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';

// 结束SSE连接
export function endSse(clientId: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/sse/end.ac?clientId=${clientId}`,
    method: 'post',
  });
}

// SSE订阅列表
export function sseSubscribeList() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/subscribe/list.ac`,
    method: 'post',
  });
}

// 订阅通知
export function subscribe(id: any, type: any, locks: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/edit/unlock/subscribe.ac?id=${id}&type=${type}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data: locks,
  });
}

// 取消订阅通知
export function unsubscribe(id: any, type: any, locks: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/edit/unlock/unsubscribe.ac?id=${id}&type=${type}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data: locks,
  });
}

// 拿商品、设计款、版单的乐观锁
export function getDistributedOptimisticLock(id: any, type: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/edit/distributedOptimisticLock.ac?id=${id}&type=${type}`,
    method: 'post',
  });
}

// 加锁
export function getLock(id: any, type: any, locks: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/edit/lock.ac?id=${id}&type=${type}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data: locks,
  });
}

// 解锁
export function unlock(id: any, type: any, locks: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/edit/unlock.ac?id=${id}&type=${type}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data: locks,
  });
}

// 强制解锁
export function forceLock(id: any, type: any, locks: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/edit/force/lock.ac?id=${id}&type=${type}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data: locks,
  });
}

// 锁列表
export function lockList(id: any, type: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/edit/lock/list.ac?id=${id}&type=${type}`,
    method: 'post',
  });
}
